import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>Datenschutzregelungen</h2>
            <p><strong>Dreamehome Datenschutzerklärung</strong></p>
            <p>Einführung</p>
            <p>Das „Dreamehome“ wird von Dreame Innovation Technology (Suzhou) Co., Ltd. und seinen verbundenen Unternehmen (im
                Folgenden als „wir“ oder „Zimu“ bezeichnet) betrieben, um Ihnen eine Plattform (oder einen Dienst) für die
                intelligente Hardwaregerätesteuerung und Verwaltungsdienste bereitzustellen ). Wir verstehen und kennen die
                Bedeutung personenbezogener Daten für Sie und werden unser Bestes tun, um die Sicherheit ihrer personenbezogenen
                Daten zu schützen. Wir werden gemäß den branchenweit anerkannten Sicherheitsstandards entsprechende
                Sicherheitsmaßnahmen ergreifen, um Ihre personenbezogenen Daten zu schützen.</p>
            <p>Bitte lesen Sie vor dem Nutzen unserer Produkte (oder Dienstleistungen) die DreamehomeDatenschutzerklärung
                sorgfältig durch.</p>
            <p>Wenn Sie minderjährig sind, müssen Sie die Erlaubnis Ihrer Eltern oder Ihres Erziehungsberechtigten haben, um
                diese
                App zu verwenden. Bitte lesen Sie diese Bedingungen gemeinsam mit ihnen.</p>
            <p>Bei der Formulierung dieser Datenschutzerklärung haben wir Ihre Bedürfnisse vollständig berücksichtigt. Es ist
                sehr
                wichtig, dass Sie unsere Erhebung und Verwendung der personenbezogenen Daten umfassend verstehen, ebenso dass
                Sie in
                der Lage sind, Ihre persönlichen Daten, die Sie uns zur Verfügung stellen, selbst zu verwalten und zu
                kontrollieren.
                Diese Datenschutzerklärung beschreibt, wie wir die Informationen, die Sie uns bei der Nutzung unserer App
                angeben,
                sammeln, verwenden, offenlegen, verarbeiten und speichern. Wir verwenden Ihre Daten unbedingt unter der
                Einhaltung
                dieser Datenschutzerklärung.</p>
            <p>Diese Datenschutzerklärung soll das Folgende beschreiben:</p>
            <p>1. Welche Daten wir sammeln und wie wir sie verwenden</p>
            <p>2. Wie wir Cookies und weitere Technologien verwenden</p>
            <p>3. Wie wir Ihre personenbezogenen Daten mit Verarbeitung betrauen, teilen, übertragen und offenlegen</p>
            <p>4. Wie wir Ihre personenbezogenen Daten speichern und schützen</p>
            <p>5. Ihre Rechte</p>
            <p>6. Wie wir die grenzüberschreitende Datenübertragung behandeln</p>
            <p>7. Unsere Kontaktdaten</p>
            <p>8. Wie wir die Datenschutzerklärung aktualisieren</p>
            <p>Anhang I: Details zum SDK von Drittanbietern</p>
            <p>Es ist unser oberstes Ziel, Ihnen die beste Benutzererfahrung zu bringen. Wir haben professionelle
                Datenschutzbeauftragte (DSB), die sich um Ihre Datenschutzfragen kümmern. Wenn Sie Fragen zu dieser
                Datenschutzerklärung haben, können Sie sich mit den Kontaktdaten in Abschnitt VII an den entsprechenden DSB
                wenden.
                Unser DSB wird Ihre Anfrage innerhalb der von den jeweiligen nationalen Gesetzen vorgeschriebenen Frist
                beantworten.
                Wenn Sie mit unserer Antwort nicht zufrieden sind, insbesondere wenn Sie glauben, dass wir bei der Verarbeitung
                Ihrer personenbezogene Daten Ihre legitimen Rechte und Interessen verletzen, können Sie eine Klage beim
                zuständigen
                Volksgericht einreichen, eine Beschwerde bei staatlichen Aufsichtsbehörden einreichen oder Ihre Probleme mit
                anderen
                externen Ansätzen lösen.</p>
            <p><strong>I. Welche Daten wir sammeln und wie wir sie verwenden</strong></p>
            <p>Personenbezogene Daten sind alle elektronisch oder auf andere Weise erfassten Daten, die allein oder gemeinsam
                mit
                anderen Daten verwendet werden können, um eine bestimmte natürliche Person zu identifizieren.</p>
            <p>Sensible personenbezogene Daten beziehen sich auf Daten, die, sobald sie offengelegt, illegal zur Verfügung
                gestellt oder missbraucht werden, die Sicherheit von Personen und Eigentum gefährden können oder zu einer
                Schädigung
                des persönlichen Rufs, der geistigen und körperlichen Gesundheit oder zu diskriminierender Behandlung usw.
                führen
                können. Zu den sensiblen personenbezogenen Daten gehören u. a. Ausweisnummern, persönliche biometrische Daten,
                Bankkonto, Eigentum, Aufenthaltsort, Transaktionsdaten und personenbezogene Daten von Minderjährigen unter 14
                Jahren
                (einschließlich), usw.</p>
            <p>Der Zweck der Erhebung Ihrer personenbezogenen Daten ist es, Ihnen Produkte und/oder Dienstleistungen
                bereitzustellen. Und wir versprechen, dass wir diese Daten gemäß den geltenden Gesetzen, Vorschriften und
                anderen
                normativen Dokumenten verwenden werden. Sie haben das Recht zu wählen, ob Sie Ihre Daten zur Verfügung stellen
                wollen. Aber wenn Sie sie nicht anbieten, sind wir meistens nicht in der Lage, Ihnen entsprechende
                Dienstleistungen
                zu erbringen und auf Ihre Anfragen zu reagieren.</p>
            <p><strong>(I) Dreamehome sammelt und verarbeitet Ihre personenbezogenen Daten, um grundlegende Dienstleistungen
                bereitzustellen.</strong></p>
            <p><strong>(1) Geräteverbindung und -verwaltung</strong></p>
            <p>Um unsere Dienstleistungen bereitzustellen, damit Sie Ihre Smart-Geräte sicher verbinden und steuern können,
                werden
                wir wahrscheinlich Ihre Daten von WiFi, Standort, Login-Konto, Mobiltelefon, Smart-Geräte und relevante Daten
                Ihres
                Dreame-Kontos und Smart-Geräts sammeln. Die Daten werden verwendet, um Funktionen wie Schnellverbindung,
                Verbindung,
                Geräte in der Nähe finden und Geräteverwaltung zu ermöglichen. Im Detail umfassen die Daten wie folgt:</p>
            <p>Login-Kontoinformationen: Ihr Dreame-Konto-Benutzername, Passwort, Spitzname, Profilfoto, E-Mail-Adresse und
                Telefonnummer. Darunter sind Ihr Benutzername, Ihr Passwort, Ihre Telefonnummer und Ihre E-Mail-Adresse sensible
                personenbezogene Daten. Diese Daten werden gesammelt, um Ihre Identität zu verifizieren und Ihnen zu helfen, die
                Erlaubnis zu erhalten, mit Ihrem Dreamehome-Konto auf den Server zuzugreifen. Der Benutzername und das Passwort,
                die
                Sie eingeben, werden verschlüsselt und zur Anmeldeauthentifizierung an den Dreame-Server übertragen.</p>
            <p>Mobiltelefonbezogene Informationen: Geräte-Identifikation (IMEI/OAID, MAC-Adresse und Android-ID), Telefonmodell,
                Systemversion, Land oder Region, Bildschirmgröße und -auflösung, CPU und relevante Informationen zum
                Displaygerät.
                Diese Informationen werden gesammelt, damit Sie die Dreamehome mit Ihren Smart-Geräten verbinden können.</p>
            <p>Smart-Geräte-Informationen: Gerätename, Modell, Version, Hersteller, Identifikation, MAC-Adresse, IP-Adresse,
                Betriebsstatus, benutzerdefinierte Eigenschaften, Einstellungsparameter, Geschäftsereignisse, Gerätesteuerung
                und
                Nutzungsaufzeichnungen. Diese Informationen werden gesammelt, um Ihr Smart-Gerät zu verbinden, damit Sie das
                Gerät
                steuern und verwalten, Geräteeigenschaften und -parameter einstellen und den Betriebsstatus und die Verlauf
                Ihres
                Geräts anzeigen können.</p>
            <p><strong>(2) Die Aktualisierung Ihrer </strong>Dreamehome<strong>Dreamehome und Ihres Smart-Geräts</strong></p>
            <p>Um sicherzustellen, dass Sie kontinuierlich unsere neuesten Dienstleistungen nutzen können, können wir Ihre
                Dreamehome-Versionsinformationen und Ihr Telefonmodell verwenden, um aktualisierte Dienstleistungen
                bereitzustellen.
                Außerdem können wir auch die Liste Ihrer angeschlossenen Geräte und Versionsinformationen sammeln, um
                aktualisierte
                Services bereitzustellen, damit Sie die neueste Version unserer Dienstleistungen (einschließlich der
                Firmware-Version) nutzen können. Dreamehome bietet nur aktualisierte Dienstleistungen für Ihre Smart-Geräte an.
                Der
                Hersteller des smarten Geräts stellt die entsprechende Firmware zur Verfügung und ist für die Qualität der
                Firmware
                und die Ergebnisse der Aktualisierung verantwortlich.</p>
            <p>Wenn Sie diese Informationen nicht angeben, können Sie Dreamehome und Ihr Smart-Gerät nicht aktualisieren.</p>
            <p><strong>(3) Online Problemrückmeldung</strong></p>
            <p>Um Ihnen bei der effektiven Lösung möglicher Probleme der Dreamehome und Ihres Smart-Geräts zu helfen, bieten wir
                einen Online-Problemrückmeldungsdienst an, für den Ihre personenbezogenen Daten erforderlich sind,
                einschließlich:
                Protokolle der Dreamehome und Ihres Smart-Geräts, Ihre Kontaktdaten, Problembeschreibungen und relevante Fotos
                und
                Videos. Die App- und Geräteprotokolle enthalten den Gerätestatus, von Sensoren erkannte Informationen,
                Gerätebetriebsaufzeichnungen, Geräteidentifikationen usw. Diese Informationen werden gesammelt, um die Ursachen
                des
                Problems zu analysieren und zu identifizieren. Ihre Kontaktdaten werden gesammelt, damit wir das Ticket
                nachverfolgen und Ihnen bei der Lösung des Problems besser helfen können.</p>
            <p>Ihre personenbezogenen Daten werden nur zur Analyse und Lösung von Problemen verwendet und sind nicht öffentlich
                zugänglich oder werden für kommerzielle Interessen verwendet. Wenn Sie diese Informationen nicht angeben, sind
                wir
                nicht in der Lage, Ihre Probleme effektiv zu identifizieren und zu lösen.</p>
            <p><strong>(II) Dreamehome sammelt und verarbeitet Ihre personenbezogenen Daten, um zusätzliche Funktionen
                bereitzustellen.</strong></p>
            <p>Neben den grundlegenden Dienstleistungen kann es erforderlich sein, dass wir Ihre personenbezogenen Daten für
                einige zusätzliche Funktionen sammeln und verwenden. Wenn Sie diese Informationen nicht angeben, können Sie zwar
                die
                grundlegenden Dienstleistungen nutzen, aber möglicherweise nicht die zusätzlichen Funktionen, die Ihnen mehr
                Komfort
                bieten können. Zusätzlich zu den grundlegenden Dienstleistungen bietet Dreamehome auch an:</p>
            <p><strong>Programm zur Verbesserung der Benutzerfreundlichkeit:</strong></p>
            <p>Um Ihre Benutzererfahrung zu verbessern, müssen wir die Dreamehome-Protokolle sammeln, einschließlich
                verschlüsselter Schlüsselprozessprotokolle, Ereignisprotokolle, Fehlerprotokolle, Geschäftsereignisse, Nutzung
                der
                einzelnen Schnittstellen usw. Ihre sensiblen personenbezogenen Daten werden nicht in den Protokollen
                aufgezeichnet.
            </p>
            <p>Ihre personenbezogenen Daten werden auf folgende Weise verwendet: Die oben genannten Daten werden automatisch
                gesammelt und auf den Server hochgeladen; die Protokolldaten werden analysiert, um den Betriebsstatus zu
                diagnostizieren und die App-Nutzung zu analysieren.</p>
            <p>Wenn Sie diese Informationen nicht angeben, kann die Dreamehome Ihre Benutzererfahrung nicht rechtzeitig
                verbessern, aber Sie können trotzdem die grundlegenden Dienstleistungen der Dreamehome<strong>(III) Wir können
                    Ihre
                    personenbezogenen Daten von Drittanbietern sammeln.</strong></p>
            <p>Unter bestimmten Umständen können wir Ihre personenbezogenen Daten rechtmäßig von Drittanbietern erwerben. </p>
            <p>Mit Ihrer Genehmigung werden wir bei der Verwaltung Ihrer Smart-Geräte mit Drittanbietern zusammenarbeiten, wobei
                wir Ihre personenbezogenen Daten von Drittanbietern sammeln werden. Wenn Sie Ihr Smart-Gerät mit einem
                Drittanbieter-Konto verwalten und Ihre App mit dem Drittanbieter-Konto verbunden ist, erhalten wir Ihre
                personenbezogenen Daten. Die folgenden Daten werden gesammelt:</p>
            <p>Ihre Drittanbieter-Kontoinformationen, einschließlich Ihres Spitznamens und Ihres Profilfotos, die in der
                Dreamehome angezeigt werden;</p>
            <p>Geräte- und Netzwerkinformationen, einschließlich der Geräteidentifikation, der MAC-Adresse und der Seriennummer
                des Geräts, um das aktuelle Gerät zu erkennen und die Sicherheitskontrolle zu ermöglichen.</p>
            <p>Wenn die Verarbeitung Ihrer personenbezogenen Daten für geschäftliche Aktivitäten den Umfang Ihrer ursprünglichen
                Autorisierung und Zustimmung bei einem Drittanbieter übersteigt, werden wir Ihre klare Zustimmung einholen,
                bevor
                wir Ihre Daten verarbeiten. Außerdem halten wir uns strikt an die Gesetze und Vorschriften und verlangen von den
                jeweiligen Drittdienstleistern, dass sie die Rechtmäßigkeit der von ihnen bereitgestellten Informationen
                garantieren.</p>
            <p><strong>(IV) Nicht-personenbezogene Daten</strong></p>
            <p>Wir können auch andere Daten sammeln, die nicht zur Identifizierung einer bestimmten Person verwendet werden
                können
                (d.h. Daten, die nicht persönlich identifizierbar sind), wie z.B. statistische Daten, die bei der Nutzung
                bestimmter
                Dienstleistungen generiert werden, wie z.B. Benutzerverhalten (einschließlich Klicks, Seitenaufrufe und
                Besuchsdauer). Diese Informationen werden gesammelt, um unsere Dienstleistungen zu verbessern. Die Arten und
                Anzahl
                der gesammelten Daten hängen davon ab, wie Sie unsere Produkte und/oder Dienstleistungen nutzen. Wir sammeln
                diese
                Daten, um Ihnen benutzerfreundlichere Informationen zu zeigen und die Kundenpräferenzen für unsere Website,
                Produkte
                und Dienstleistungen besser zu analysieren, damit wir unsere Dienstleistungen optimieren können. In dieser
                Datenschutzerklärung werden solchen gesammelten Daten als nicht-personenbezogene Informationen betrachtet. Wenn
                wir
                nicht-personenbezogene Daten mit personenbezogenen Daten kombinieren, werden die nicht-personenbezogenen Daten
                wieder als personenbezogene Daten betrachtet.</p>
            <p><strong>II. Wie wir Cookies und weitere Technologien verwenden</strong></p>
            <p>Um die normalen Funktionen der Dreamehome zu gewährleisten, speichern wir eine kleine Datendatei namens „Cookie“
                auf Ihrem Gerät. Das Cookie enthält normalerweise Identifikatoren, Website-Namen und einige Nummern und Zeichen.
                Mit
                Hilfe von Cookie kann Dreamehome Ihr Website-Login-Konto, Ihre Einstellungen und andere Daten speichern.</p>
            <p>Wir verwenden Cookies nur für die in dieser Datenschutzerklärung genannten Zwecke. Sie können Cookies nach Ihren
                Wünschen verwalten oder löschen. Aber wenn Sie dies vornehmen, kann in einigen Fällen Ihr sicherer Zugang zu
                Dreamehome beeinträchtigt sein, und Sie müssen möglicherweise bei jedem Zugriff auf Dreamehome die
                Benutzereinstellungen ändern.</p>
            <p><strong>III. Wie wir Ihre personenbezogenen Daten mit Verarbeitung betrauen, teilen, übertragen und
                offenlegen.</strong></p>
            <p><strong>(I) Betraute Verarbeitung</strong></p>
            <p>Unter bestimmten Umständen kann Dreame andere Unternehmen mit der Verarbeitung Ihrer personenbezogenen Daten
                betrauen, z. B. um Sie zu kontaktieren, E-Mails zu versenden oder technischen Support zu leisten. Diese
                Unternehmen
                dürfen Ihre personenbezogenen Daten nur verwenden, um in unserem Namen Dienstleistungen für Sie zu erbringen.
            </p>
            <p>Wir unterzeichnen eine strenge Vertraulichkeitsvereinbarung oder eine Vereinbarung zur Verarbeitung
                personenbezogener Daten mit der beauftragten Partei und verpflichten sie, personenbezogene Daten gemäß dieser
                Datenschutzerklärung zu verarbeiten und entsprechende Vertraulichkeits- und Sicherheitsmaßnahmen zu ergreifen.
            </p>
            <p><strong>(II) Datenteilung</strong></p>
            <p>Im Allgemeinen wird Dreame Ihre personenbezogenen Daten nicht mit anderen Unternehmen, Organisationen oder
                Personen
                teilen, außer in den folgenden Fällen:</p>
            <p>1. Mit Ihrer Zustimmung werden wir die Daten mit Dritten teilen. Dazu gehören, dass die Informationen und die
                Konfiguration Ihrer Smart-Home-Produkte an Ihre Freunde und Familie weitergeschickt werden, um ihnen einen
                schnellen
                Zugriff auf die Software und Dienstleistungen auf ihren Endgeräten zu ermöglichen.</p>
            <p>2. Einige Dienstleistungen der Dreamehome, wie z. B. Website-Hosting, Datenanalyse, Zahlungs- und
                Kreditkartenabwicklung, Infrastrukturbereitstellung, IT-Dienstleistungen, Kundensupport-Dienstleistungen,
                E-Mail-Versandservice und andere Dienstleistungen, werden von Drittanbietern bereitgestellt. Aus diesem Grund
                müssen
                wir einige Ihrer personenbezogenen Daten an die Drittdienstleister weitergeben, damit sie diese Dienstleistungen
                für
                uns erbringen können</p>
            <p>3. Wir können Ihre personenbezogenen Daten mit Kunden und andere Geschäftspartner teilen, die direkt oder
                indirekt
                Smart-Geräte und/oder Netzwerke und Systeme zur Verfügung stellen, damit Sie auf unsere Website und
                Dienstleistungen
                zugreifen und diese nutzen können.</p>
            <p>4. Wenn Dreame in eine Umstrukturierung, Fusion, einen Verkauf von Vermögenswerten, ein Joint Venture, eine
                Abtretung, eine Übertragung oder andere Umstände involviert ist, bei denen unser gesamtes Geschäft, unsere
                Vermögenswerte oder Bestände oder Teile davon veräußert werden müssen (einschließlich, aber nicht beschränkt auf
                Konkurs- oder ähnliche Verfahren im Zusammenhang mit den oben genannten Umständen), können wir Ihre
                personenbezogenen Daten mit verbundene Unternehmen oder andere Drittunternehmen teilen. Zuvor erhalten Sie eine
                eindeutige Benachrichtigung per E-Mail und/oder über unsere Website über die Änderung der Eigentumsverhältnisse,
                die
                Unvereinbarkeit der neuen Verwendung Ihrer personenbezogenen Daten und die Genehmigung Ihrer personenbezogenen
                Daten.</p>
            <p>5. Wenn wir es für notwendig oder angemessen halten, Ihre Daten zu teilen: (a) geltende Gesetze und Vorschriften
                einzuhalten; (b) rechtliche Verfahren durchzuführen; (c) auf die Anforderungen öffentlicher Institutionen und
                Behörden zu reagieren, auch außerhalb des Landes/der Region, in dem/der Sie wohnen; (d) unsere
                Geschäftsbedingungen
                zu erfüllen; (e) unseren Betrieb, unser Geschäft und unsere Systeme zu schützen; (f) die Rechte, die
                Privatsphäre,
                die Sicherheit oder das Eigentum von uns und/oder anderen Nutzern, einschließlich Ihnen, zu schützen; und (g)
                verfügbare Rechtsbehelfe zu suchen oder den Schadenersatz zu begrenzen, den wir möglicherweise leisten müssen.
            </p>
            <p>6. Wir können Ihre personenbezogenen Daten mit unseren Niederlassungen oder verbundenen Unternehmen teilen, um
                regelmäßig geschäftliche Aktivitäten durchzuführen.</p>
            <p>7.wir werden notwendige Daten mit Dritten über Anwendungsprogrammierschnittstellen (APIs) und
                Software-Entwicklungskits (SDKs) teilen. Die SDKs von Drittanbietern variieren von verschiedenen Versionen und
                umfassen im Allgemeinen Anmeldetypen für Drittanbieterkonten, Freigabetypen und Zahlungsarten für
                Drittanbieterkonten, Push-Typen von Herstellern, Statistiktypen usw. Wir führen strenge Sicherheitsprüfungen bei
                Drittanbietern durch und vereinbaren Datenschutzmaßnahmen. In Anhang 1 haben wir die Details der SDKs von
                Drittanbietern aufgelistet, auf die wir zugreifen dürfen, bitte lesen Sie diese sorgfältig durch. Unsere
                Datenschutzerklärung gilt nicht für Produkte oder Dienstleistungen, die von einem Drittanbieter bereitgestellt
                werden. Wenn Sie diese Produkte oder Dienstleistungen nutzen, können Ihre personenbezogenen Daten gesammelt
                werden.
                Daher empfehlen wir Ihnen dringend, die Datenschutzerklärung der Drittanbieter zu lesen. Wir haben keine
                Verantwortung dafür und keine Kontrolle darüber, wie Drittanbieter die von Ihnen gesammelten Daten verwenden.
                Unsere
                Datenschutzerklärung gilt nicht für andere Webseiten, die über unsere Dienstleistungen verlinkt sind. Sie
                sollten
                für die Sicherheit Ihrer personenbezogenen Daten verantwortlich sein, während Sie mit den verlinkten Websites
                interagieren. Bevor Sie die Seite des Drittanbieters zum ersten Mal besuchen, werden Ihnen die entsprechenden
                Vereinbarungen und Datenschutzerklärung des Drittanbieters angezeigt. Bitte lesen Sie deren Erklärungen
                sorgfältig
                durch.</p>
            <p><strong>(III) Datenübertragung</strong></p>
            <p>Dreame wird Ihre personenbezogenen Daten nicht an Unternehmen, Organisationen oder Personen übertragen, außer in
                den folgenden Fällen:</p>
            <p>1. Mit Ihrer Zustimmung: Wir werden Ihre personenbezogenen Daten nur nach Ihrer expliziten Zustimmung an andere
                Parteien übertragen;</p>
            <p>2. Wenn Dreame in eine Fusion, Übernahme oder Konkursliquidation involviert ist, die eine Übertragung von
                personenbezogenen Daten erfordert, verlangen wir von dem neuen Unternehmen oder der neuen Organisation, das/die
                Ihre
                personenbezogenen Daten besitzt, weiterhin an diese Datenschutzerklärung gebunden zu sein; andernfalls verlangen
                wir
                von dem Unternehmen oder der Organisation, die Genehmigung von Ihnen erneut einzuholen.</p>
            <p><strong>(IV) Weitergabe</strong></p>
            <p>Wir legen Ihre persönlichen Daten nicht offen, außer unter den folgenden Umständen:</p>
            <p>1. Mit Ihrer expliziten Zustimmung;</p>
            <p>2. Wenn wir eine rechtliche Grundlage haben: Wir können Ihre personenbezogenen Daten gemäß dem Gesetz oder
                aufgrund
                von Gerichtsverfahren, Rechtsstreitigkeiten oder zwingenden Anforderungen von Regierungsbehörden offenlegen.</p>
            <p><strong>IV. Wie wir Ihre persönlichen Daten speichern und schützen</strong></p>
            <p>Wir speichern Ihre personenbezogenen Daten so lange, wie es für den in dieser Datenschutzerklärung beschriebenen
                Zwecke der Datenerhebung erforderlich ist, oder wie es die geltenden gesetzlichen Anforderungen erfordern. Wir
                speichern Ihre personenbezogenen Daten nicht mehr und löschen oder anonymisieren sie, nachdem wir den Zweck der
                Datenerhebung abgeschlossen haben, oder nachdem wir Ihren Antrag auf Löschung oder Stornierung bestätigt haben,
                oder
                nachdem wir den Betrieb entsprechender Produkte oder Dienstleistungen eingestellt haben. Zu Zwecken des
                öffentlichen
                Interesses, der wissenschaftlichen oder historischen Forschung oder zu statistischen Zwecken werden wir die
                entsprechenden Daten in Übereinstimmung mit dem geltenden Gesetz weiter speichern, auch wenn die weitere
                Datenverarbeitung nichts mit dem ursprünglichen Zweck zu tun hat.</p>
            <p>Die spezifische Speicherdauer Ihrer personenbezogenen Daten in der Dreamehome lautet wie folgt:</p>
            <p>Für Daten, die lokal in der Dreamehome gespeichert sind, werden alle gespeicherten Daten sofort gelöscht, wenn
                Sie
                die Dreamehome oder die Dreamehome-Daten löschen.</p>
            <p>Für das Smart-Gerät und die auf dem Server gespeicherten geschäftlichen Daten werden alle gespeicherten Daten
                sofort gelöscht, wenn Sie das Smart-Gerät löschen, die Datenschutzerklärung von Dreamehome ablehnen und die
                Dienstleistungen von Dreamehome nicht mehr nutzen.</p>
            <p>Geschäftsprotokolle, statistische Daten und Verlaufsdaten, die auf dem Server gespeichert sind, werden von uns
                bei
                der Bereinigung der Serverdaten von Zeit zu Zeit gelöscht. Normalerweise werden die Daten nicht länger als 2
                Jahre
                gespeichert.</p>
            <p>Falls Dreame den Betrieb der entsprechenden Produkte oder Dienstleistungen einstellt, werden wir Sie außerdem
                durch
                Push-Benachrichtigungen, Ankündigungen usw. informieren und Ihre personenbezogenen Daten innerhalb eines
                angemessenen Zeitraums löschen oder anonymisieren.</p>
            <p><strong>V. Ihre Rechte</strong></p>
            <p><strong>(I) Ihr Recht auf Zugriff, Berichtigung und Löschung Ihrer personenbezogenen Daten</strong></p>
            <p>Gemäß den geltenden regionalen Gesetzen und Vorschriften haben Sie das Recht, Zugriff zu den von uns gesammelten
                Daten zu verlangen, diese Daten zu berichtigen oder zu löschen (im Folgenden als "Antrag" bezeichnet). Bitte
                schreiben Sie uns oder kontaktieren Sie uns, indem Sie Dreamehome besuchen. Die meisten Gesetze schreiben vor,
                dass
                der Antrag eines Betroffenen auf personenbezogene Daten bestimmte Anforderungen erfüllen muss. Die Anforderungen
                umfassen:</p>
            <p>Der Antrag sollte über unsere speziellen Antragskanäle gestellt werden. Um die Sicherheit Ihrer personenbezogenen
                Daten zu gewährleisten, sollte der Antrag in schriftlicher Form vorliegen (es sei denn, das regionale Gesetz
                erkennt
                einen mündlichen Antrag eindeutig an);</p>
            <p>Sie müssen uns genügend Informationen zur Verfügung stellen, damit wir Ihre Identität überprüfen und
                sicherstellen
                können, dass der Antrag vom Benutzer selbst oder einer vom Benutzer rechtlich autorisierten Person gestellt
                wird;
            </p>
            <p>Sobald wir genügend Informationen erhalten, um zu bestätigen, dass wir Ihren Antrag bearbeiten können, werden wir
                Ihnen innerhalb der von den geltenden Datenschutzgesetzen vorgeschriebenen Frist antworten. Genauer gesagt,
                umfassen
                unsere Antworten:</p>
            <p>Basierend auf Ihrem Antrag und den geltenden Gesetzen und Vorschriften können wir Ihnen eine Kopie Ihrer Daten,
                die
                wir gesammelt und verarbeitet haben, kostenlos anbieten. Für weitere Anträge auf relevante Daten können wir eine
                angemessene Gebühr in Rechnung stellen, die auf unseren Verwaltungskosten basiert.</p>
            <p>Wenn Sie glauben, dass Ihre bei uns gespeicherten Daten unrichtig oder unvollständig sind, können Sie die
                Berichtigung oder Vervollständigung der Daten anhand des Verwendungszwecks verlangen.</p>
            <p>Gemäß den geltenden Gesetzen und Vorschriften haben Sie das Recht, die Löschung Ihrer personenbezogenen Daten zu
                verlangen. Ihr Antrag wird geprüft. Wenn es mit den geltenden Gesetzen und Vorschriften entspricht, werden wir
                Ihre
                Daten mit entsprechenden Verfahren einschließlich technischer Maßnahmen löschen. Nachdem relevante Daten
                gelöscht
                werden, kann es sein, dass wir aufgrund der betreffenden Gesetze und Sicherheitstechnologien nicht in der Lage
                sind,
                die Daten sofort aus dem Sicherungssystem zu löschen. In diesem Fall werden wir Ihre personenbezogenen Daten
                sicher
                speichern und sie von jeder weiteren Verarbeitung isolieren, bis sie gelöscht oder anonymisiert werden können.
                Gemäß
                dem E-Commerce-Gesetz von Volksrepublik China müssen beispielsweise Ihre Produkt- und Dienstleistungsdaten sowie
                Transaktionsdaten für einen Zeitraum von mindestens drei Jahren ab dem Tag des Abschlusses der Transaktion
                gespeichert werden.</p>
            <p>Wir haben das Recht, die Bearbeitung eines Antrags in folgenden Fällen abzulehnen: Der Antrag ist unbegründet
                oder
                strittig; Der Antrag kann die Privatsphäre anderer verletzen; Der Antrag ist extrem unrealistisch; Der Antrag
                erfordert einen unverhältnismäßigen technischen Aufwand; Der Antrag kann gemäß den regionalen Gesetzen ignoriert
                werden; Die Daten wurden bereits offengelegt; Die Daten wurden unter Vertraulichkeitsbedingungen freigegeben.
                Falls
                wir glauben, dass der Antrag auf Löschung oder Zugriff auf Daten uns in einigen Fällen an der legalen Nutzung
                der
                Daten für die oben genannten Zwecke der Betrugsbekämpfung und Sicherheit hindern könnte, können wir den Antrag
                ebenfalls ablehnen.</p>
            <p><strong>(II) Widerruf der Zustimmung</strong></p>
            <p>Sie können Ihre Einwilligung widerrufen, indem Sie eine Anfrage stellen, einschließlich der Erhebung, Verwendung
                und/oder Offenlegung Ihrer personenbezogenen Daten, die wir erfassen oder kontrollieren. Je nach den von Ihnen
                genutzten Diensten können Sie uns für entsprechende Handlungen über die Kontaktinformationen in Abschnitt 7
                dieser
                Datenschutzerklärung kontaktieren. Wir werden Ihre Anfrage innerhalb eines angemessenen Zeitraums nach der
                Anfrage
                bearbeiten und Ihre personenbezogenen Daten gemäß Ihrer Anfrage nicht mehr erheben, verwenden und/oder
                offenlegen.
            </p>
            <p>Bitte beachten Sie, dass Sie je nach dem Umfang, in dem Sie uns zur Verarbeitung Ihrer Daten ermächtigen, als
                Folge
                Ihres Widerrufs der Zustimmung möglicherweise nicht mehr in der Lage sind, auf die Dienstleistungen der
                Dreamehome
                oder der mit dieser verbundenen Smart-Geräte zuzugreifen. Ihre Entscheidung, Ihre Zustimmung oder Autorisierung
                zu
                widerrufen, hat jedoch keinen Einfluss auf die vorherige Verarbeitung personenbezogener Daten aufgrund Ihrer
                früheren Genehmigung.</p>
            <p>Sie können auch aus dem Programm zur Verbesserung der Benutzerfreundlichkeit aussteigen, indem Sie den Widerruf
                der
                Zustimmung beantragen oder Dreamehome besuchen.</p>
            <p><strong>(III) Dreamehome Konto löschen</strong></p>
            <p>Sie können Dreamhome-Konto löschen, indem Sie "Mein"-"Kontoeinstellungen"-"Konto löschen" aufrufen. Wenn Sie Ihr
                Dreamehome-Konto kündigen würden, könnten Sie nach der Kündigung die Nutzung von Dreamehome und seiner gesamten
                Produkt- und Dienstleistungs der intelligenter Hardware nicht mehr verwenden .Bitte gehen Sie mit Vorsicht vor.
                Um
                die legitimen Rechte und Interessen von Ihnen oder anderen zu schützen, werden wir Ihrer Nutzung der
                Smart-Hardware-Produkte und -Dienste von Dreamhome in Betracht ziehen und uns entscheiden, ob wir Ihre Anfrage
                zulassen.</p>
            <p><strong>VI. Wie wir die grenzüberschreitende Datenübertragung behandeln</strong></p>
            <p>Da wir unsere Produkte oder Dienstleistungen über Ressourcen und Server auf der ganzen Welt bereitstellen, können
                Ihre personenbezogenen Daten mit Ihrer Zustimmung in andere Länder/Regionen, in der Sie die Produkte oder
                Dienstleistungen nutzen, übertragen werden oder von diesen Ländern/Regionen abgerufen werden. Die
                Datenschutzvorschriften und die relevanten Gesetze in andere Länder/ Regionen sind möglicherweise nicht so
                umfassend. In diesem Fall werden wir angemessene Maßnahmen gemäß den geltenden Gesetzen der jeweiligen
                Länder/Regionen ergreifen, um sicherzustellen, dass Ihre persönlichen Daten weiterhin geschützt sind.</p>
            <p>Hinweis:</p>
            <p>Wenn Sie im Europäischen Wirtschaftsraum (EWR) ansässig sind und Ihre personenbezogenen Daten außerhalb des EWR
                übertragen werden, werden wir: Ihre personenbezogenen Daten in dem Gebiet verarbeiten, das von der Europäischen
                Kommission als angemessenes Schutzniveau eingestuft wurden, oder angemessene Schutzmaßnahmen ergreifen, um Ihre
                personenbezogenen Daten zu schützen, einschließlich der Übertragung Ihrer Daten gemäß den geltenden
                Datenübertragungsvorschriften, wie z. B. den Standardvertragsklauseln der Europäischen Kommission (SCC).</p>
            <p><strong>VII. Kontakt</strong></p>
            <p>Wenn Sie Kommentare oder Fragen zu dieser Datenschutzerklärung oder zu unserer Erhebung, Verwendung oder
                Weitergabe
                Ihrer persönlichen Daten haben, kontaktieren Sie uns bitte über die unten dargelegten Kontaktdaten oder indem
                Sie
                Dreamehome "Mein"-"Folgen und Feedback"besuchen und die Nachricht mit "Datenschutzerklärung" überschreiben.
                Unser
                professionelles Team wird sich um Ihre Fragen und Probleme kümmern. Wenn Ihre Frage eher wichtige
                Angelegenheiten
                betrifft, können wir Sie bitten, weitere Informationen zur Verfügung zu stellen. Wenn Sie mit unserer Antwort
                nicht
                zufrieden sind, können Sie eine Beschwerde bei der zuständigen Aufsichtsbehörde in Ihrer Region einreichen. Wenn
                Sie
                sich an uns wenden, um sich über die Beschwerdewege zu informieren, werden wir Ihnen je nach Ihrer konkreten
                Situation die entsprechenden Möglichkeiten anbieten.</p>
            <p><strong>Kontaktdaten:</strong></p>
            <p><strong>E-Mail-Addresse:</strong></p>
            <p>Kontaktdaten in China: <a className="page"
                href="mailto:privacy@dreame.tech">privacy@dreame.tech</a> </p>
            <p>Kontaktdaten des DPO von Singapur: <a className="page"
                href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a> </p>
            <p>Kontaktdaten des EU-Vertreters: <a className="page"
                href="mailto:representative.dreame@herrero.es">representative.dreame@herrero.es</a> </p>
            <p><strong>Kontaktnummer:</strong> 400-875-9511</p>
            <p><strong>Website:</strong> <a className="page"
                href="https://www.dreametech.com/ ">https://www.dreametech.com/ </a> </p>
            <p><strong>VIII. Wie wir diese Erklärung aktualisieren</strong></p>
            <p>Dreame behält sich das Recht vor, diese Datenschutzerklärung zeitgerecht zu aktualisieren. Bei Änderungen werden
                wir Sie durch eine Pop-up-Nachricht oder andere auffällige Weise informieren. Nur mit Ihrer Zustimmung werden
                wir
                Ihre personenbezogenen Daten nach der aktualisierten Erklärung sammeln, verwenden und speichern.</p>
            <p>Diese Erklärung tritt mit dem Datum der Aktualisierung in Kraft.</p>
            <p>Letztes Aktualisierungsdatum: 28/08/2021</p>
            <p><strong>Anhang I: Details zu SDKs von Drittanbietern</strong></p>
            <p>*Die Dreamehome verwendet eine Reihe von SDKs von Drittanbietern, um Ihnen professionellere und sicherere Grund-
                und Zusatzfunktionen und -dienstleistungen anzubieten. Lesen Sie im Folgenden mehr Details über die in der
                Dreamehome verwendeten Drittanbieter-SDKs:</p>
            <div className='tableStyle'>
                <table>
                    <tr>
                        <td>
                            <p>SDKs</p>
                        </td>
                        <td>
                            <p>Funktionen</p>
                        </td>
                        <td>
                            <p>Gesammelte Daten</p>
                        </td>
                        <td>
                            <p>Datenschutzerklärungn von Drittanbietern</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Umeng statistische Analyse SDK</p>
                        </td>
                        <td>
                            <p>Statistikanalyse</p>
                        </td>
                        <td>
                            <p>Geräteidentifikation (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, IMSI INFO VON SIM-KARTEN), Standort</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Umeng Push-Benachrichtigung SDK</p>
                        </td>
                        <td>
                            <p>Push-Benachrichtigung</p>
                        </td>
                        <td>
                            <p>Geräteidentifikation (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, IMSI INFO VON SIM-KARTEN), Standort</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Umeng U-share SDK</p>
                        </td>
                        <td>
                            <p>Teilen mit Drittanbietern</p>
                        </td>
                        <td>
                            <p>Geräteidentifikation (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, IMSI INFO VON SIM-KARTEN), Standort</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Agora SDK</p>
                        </td>
                        <td>
                            <p>Aktivieren von Sprach-Chat und Video-Streaming</p>
                        </td>
                        <td>
                            <p>Geräteinformationen, Netzwerkstatus, Kamera, Mikrofon, Speicher lesen und schreiben</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Huawei data-push SDK</p>
                        </td>
                        <td>
                            <p>Data-push</p>
                        </td>
                        <td>
                            <p>Geräteidentifikation </p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Xiaomi data-push SDK</p>
                        </td>
                        <td>
                            <p>Data-push</p>
                        </td>
                        <td>
                            <p>Geräteidentifikation, Gerätemodell, Netzwerktyp, Gerätespeicher, Prozessinformationen des Geräts,
                                Applikationsversion, SDK-Version</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>OPPO data-push SDK</p>
                        </td>
                        <td>
                            <p>Data-push</p>
                        </td>
                        <td>
                            <p>Geräteidentifikation</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>VIVO data-push SDK</p>
                        </td>
                        <td>
                            <p>Data-push</p>
                        </td>
                        <td>
                            <p>Geräteidentifikation </p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>WeChat SDK</p>
                        </td>
                        <td>
                            <p>WeChat-Anmeldung, Teilen mit WeChat </p>
                        </td>
                        <td>
                            <p>Geräteidentifikation, Netzwerkinformationen</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>QQ SDK</p>
                        </td>
                        <td>
                            <p>Teilen mit QQ</p>
                        </td>
                        <td>
                            <p>Geräteidentifikation, Netzwerkinformationen</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Weibo SDK</p>
                        </td>
                        <td>
                            <p>Weibo-Anmeldung, Teilen mit Weibo</p>
                        </td>
                        <td>
                            <p>Geräteidentifikation, Netzwerkinformationen</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Apple ID SDK</p>
                        </td>
                        <td>
                            <p>Apple ID-Anmeldung</p>
                        </td>
                        <td>
                            <p>Apple ID</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.apple.com/legal/privacy/szh/">https://www.apple.com/legal/privacy/szh/</a></p>
                        </td>
                    </tr>
                </table>
            </div>
            <div className='height'></div>
        </div>
    )
}

export default PricacyPolicy